import {useQuery} from '@tanstack/react-query'
import {httpConfirmEmailRequest} from '@features/settings/http/settings.http.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {captureException} from '@sentry/core'
import {parseAxiosPromise} from '@/axiosInstance'
import {z} from 'zod'

export const useConfirmEmailRequest = (token: string) =>
    useQuery({
        queryKey: [QUERY_KEYS.CONFIRM_EMAIL, token],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpConfirmEmailRequest({params: {token}}),
                responseShape: z.object({
                    email: z.string().min(1)
                }),
                onZodError: captureException
            })
    })
